import React, { useMemo, useState } from 'react';
import debounce from 'lodash/debounce';
const DEFAULT_DEBOUNCE_OPTIONS = {
    leading: true
};
function useDebounced(func, wait, options = DEFAULT_DEBOUNCE_OPTIONS) {
    return useMemo(()=>debounce(func, wait, options), [
        func,
        wait,
        options
    ]);
}
export default function useDebouncedState(initialState, wait, options) {
    const [state, setState] = useState(initialState);
    const debouncedSetState = useDebounced(setState, wait, options);
    return [
        state,
        debouncedSetState
    ];
}

//# sourceMappingURL=useDebouncedState.js.map